/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the `duration` of a `token` is invalid
 * @export
 * @class AuthInvalidTokenDurationError
 * @extends {Error}
 */
export class AuthInvalidTokenDurationError extends Error {
  /**
   * Creates an instance of AuthInvalidTokenDurationError
   * @param {string} message The Error `message`
   * @memberof AuthInvalidTokenDurationError
   */
  constructor(message) {
    super(message);
    this.name = `AuthInvalidTokenDurationError`;
  }
}

/**
 * Called when the `duration` of a `token` is invalid
 * @param {any} duration The invalid `duration`
 * @returns {never} never
 */
const throwAuthInvalidTokenDurationError = (duration) => {
  throw new AuthInvalidTokenDurationError(
    stripIndent(`
    Expected "duration" to be a Number that is greater than 0.
    Got: "${duration}".
    `),
  );
};

export default throwAuthInvalidTokenDurationError;
